module.exports = __webpack_public_path__ + "static/media/down-arrow.cd2e33ff.svg";